'use client';
import { clc } from '@/legacy/components/base/utils';
import styles from '@/legacy/components/btn/SocialBtn.module.scss';
import { doSignInWithApple, doSignInWithGoogle2 } from '@/model/firebase/auth';
import Image from 'next/image';

type Props = {
	authType: 'login' | 'signup';
	social: 'Apple' | 'Google';
};

const onClick = async (type: Props['social'], callback: Props['authType']) => {
	if (type === 'Google') {
		// doSignInWithGoogle(callback)
		doSignInWithGoogle2(callback);
	}

	if (type === 'Apple') {
		doSignInWithApple(callback);
	}
};
const SocialBtn = ({ authType, social }: Props) => {
	return (
		<button
			className={clc(styles.social, styles[social])}
			onClick={() => {
				onClick(social, authType);
			}}
			type="button"
		>
			<div className={styles.wrap}>
				<div className={styles.icon}>
					{social === 'Apple' && <Image alt="Apple" fill src="/icon/svgs/Apple.svg" />}
					{social === 'Google' && <Image alt="Google" fill src="/icon/svgs/Google.svg" />}
				</div>
				{/* <span className={styles.text}>{t(`${social}`)}</span> */}
			</div>
		</button>
	);
};

export default SocialBtn;
